import React, { useEffect, useState } from 'react';
import Moment from 'moment'
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RotatingLines } from 'react-loader-spinner';


const SchedulePickup = ({ setSelectedTime, setSelectedDate, isLoading, dropLocations, pickupLocations, quoteData, packageItem, handleBackSteps, handleSteps }: any) => {



  const today = Date.now()
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };

  const [data, setData] = useState([
    { time: "10.00 AM - 12.00 AM", active: false },
    { time: "12.00 AM - 2.00 PM", active: false },
    { time: "2.00 PM - 4.00 PM", active: false },
    { time: "4.00 PM - 6.00 PM", active: false }
  ])

  const [data1, setData1] = useState([
    { date: Moment().add(0, 'days').format("DD"), week: 'M', active: false },
    { date: Moment().add(1, 'days').format("DD"), week: 'Tu', active: false },
    { date: Moment().add(2, 'days').format("DD"), week: 'W', active: false },
    { date: Moment().add(3, 'days').format("DD"), week: 'Th', active: true },
    { date: Moment().add(4, 'days').format("DD"), week: 'F', active: false },
    { date: Moment().add(5, 'days').format("DD"), week: 'Sa', active: false },
    { date: Moment().add(6, 'days').format("DD"), week: 'Sa', active: false }])

  const handleTiming = (e: any) => {
    const newTime = data.map(p =>
      p.time === e
        ? { ...p, active: true }
        : { ...p, active: false }
    );
    setData(newTime)
  }

  const handleDay = (e: any) => {

    const newDay = data1.map(p =>
      p.date === e
        ? { ...p, active: true }
        : { ...p, active: false }
    );
    setData1(newDay)

  }
  useEffect(() => {
    const activeDate = data1.find((item) => item.active);
    if (data1 && activeDate) {
      const currentYear = new Date().getFullYear(); // Get the current year dynamically
      const currentMonth = new Date().getMonth() + 1; // Get the current month 
      const fullDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${activeDate.date}`;
      setSelectedDate(fullDate);
    }
  }, [data1]);

  useEffect(() => {
    const activeDate = data.find((item) => item.active);
    if (data && activeDate) {
      setSelectedTime(activeDate?.time);
    }
  }, [data])

  return (
    <div className="flex flex-row justify-center  items-center  h-screen">
      <div className="overflow-auto min-h-[575px] h-[575px] bg-white shadow-xl m-3 min-w-[400px] w-[400px]">
        <div className="flex flex-col justify-center items-start p-6 space-y-5">
          <div className='text-xl font-semibold '>Order Summary</div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Package Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="cursor-pointer  hover:text-hilight opacity-50 hover:opacity-100">
              <IoIosArrowBack size={20} onClick={handleLeftScroll} />
            </div>
            {packageItem?.slice(currentIndex, currentIndex + 1)?.map((packageItemData: any, index: any) => (
              <div key={index} className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mx-2">
                <div className="pb-4">
                  <label className="text-md font-semibold block">Product</label>
                  <label className="text-base block mt-1">{packageItemData.productName}</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Weight</label>
                  <label className="text-base block mt-1">{packageItemData.weight} kg</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Product Category</label>
                  <label className="text-base block mt-1">{packageItemData.categoryName}</label>
                </div>
                <div className="pb-4">
                  <label className="text-md font-semibold block">Package Value</label>
                  <label className="text-base block mt-1">₹ {packageItemData.value}</label>
                </div>
              </div>
            ))}
            <div className="cursor-pointer  hover:text-hilight opacity-50 hover:opacity-100">
              <IoIosArrowForward size={20} onClick={handleRightScroll} />
            </div>
          </div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Address Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-1 md:grid-cols-1 gap-4">
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Pickup Address
              </label>
              <label className="text-base block mt-1">
                {pickupLocations?.description}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Drop Address
              </label>
              <label className="text-base block mt-1">
                {dropLocations?.description}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-lg pr-5 font-semibold">
                Shipping Option
              </label>
              <label className="text-base ">
                {quoteData?.shipping}
              </label>
            </div>

          </div>
        </div>
      </div>
      <div className="overflow-auto bg-white shadow-xl m-3 min-w-[900px]">
        <div className="flex flex-col justify-center items-start p-10 space-y-5">
          <div className='text-xl font-semibold '>Schedule Pickup</div>
          <div className='text-md font-normal'>Select Date  </div>
          <div className='flex flex-wrap ml-3 w-[800px]'>
            {data1.map((obj, index) => {
              return <div
                onClick={() => handleDay(Moment().add(index, 'days').format("DD"))}
                className={obj.active ? 'p-2 m-3 cursor-pointer bg-primary text-light w-max rounded-md' : 'p-2 cursor-pointer m-3 bg-slate-200 w-max rounded-md'} >
                <div className='flex flex-col justify-center items-center space-y-1 p-2'>
                  <div className='text-xl'>{Moment().add(index, 'days').format("DD")}</div>
                  <div className='text-sm'> {Moment().add(index, 'days').format("dddd").slice(0, 2)}</div>
                </div>
              </div>
            })}
          </div>
          <div className='text-md font-normal'>Select Time</div>
          <div className='flex flex-wrap ml-3 w-[650px]'>
            {data.map((obj, index) => {
              return <div
                onClick={() => handleTiming(obj.time)}
                className={obj.active ? 'text-xs cursor-pointer p-2 m-3 bg-primary text-light w-max rounded' : 'text-xs cursor-pointer p-2 m-3 bg-slate-200 w-max rounded'}>
                {obj.time}</div>
            })}
          </div>
          <div className='w-full flex justify-end px-10 space-x-3'>
            <button
              onClick={handleBackSteps}
              className='px-4 py-2 bg-primary text-light'>Back</button>
            <button
              onClick={handleSteps}
              disabled={isLoading}
              className={`${isLoading ? 'bg-primary  bg-opacity-80' : 'bg-primary'} flex items-center justify-center px-4 py-2 text-light`}
            >
              Next
              <div
                className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}
              >
                <RotatingLines
                  visible={true}
                  width={'16'}
                  strokeColor="#fff"
                  strokeWidth="6"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            </button>




          </div>
        </div>
      </div>
    </div >
  );
};

export default SchedulePickup;
